module.exports = {"en":{"activerecord":{"models":{"user":"Account"},"attributes":{"user":{"email":"Email"}}}}}